module.exports = __webpack_public_path__ + "static/media/requirement-background.e9126601.png";